module.exports = __webpack_public_path__ + "img/Subtract.969ab3ea.svg";